<template>
    <transition name="fade" mode="out-in" appear>
        <div class="notifications-holder" v-if="displayed" :key="notification.title" :class="notification.type">
            <div class="notify-category">
                <p>{{translate(notification.type)}}</p>
            </div>
            <h3>{{notification.title}}</h3>
            <h4>{{notification.content}}</h4>
            <div class="actions">
                <div @click="showModal" v-if="notification.type==='warning_temp'" class="close-btn reload">
                    <span>{{translate('send_your_request')}}</span>
                </div>
                <div @click="reloadApp" v-if="notification.type==='reload'" class="close-btn reload">
                    <span>{{translate('refresh_app')}}</span>
                </div>
                <div @click="removeMessage" class="close-btn">
                    <span>{{translate('close')}}</span>
                </div>
            </div>
        </div>
        <third-step-modal-mail v-if="isModalVisible"
                                   @close="closeModal"
                                   :target="'fan'">
        </third-step-modal-mail>
    </transition>
</template>

<script>
    import ThirdStepModalMail from "../configuration_steps/thirdStep/ThirdStepModalMail";

    export default {
        components: {ThirdStepModalMail},
        data() {
            return {
                displayed: false,
                notification: false,
                isModalVisible: false
            }
        },
        methods: {
            removeMessage: function () {
                this.$store.commit('removeNotification');
                if(this.notification && this.notification.type === 'reload') {
                    this.$store.state.events.needReload = false;
                }
            },

            showModal() {
                this.removeMessage();
                this.isModalVisible = true;
            },

            closeModal() {
                this.isModalVisible = false;
            },

            reloadApp: function() {
              this.$router.replace('/').catch(()=>{});
              window.location.reload();
              this.removeMessage();
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getNotification,
                (newValue) => {
                    if (this.$store.getters.getNotification === false) {
                        this.displayed = false;
                    } else {
                        this.displayed = true;
                        this.notification = newValue;
                    }
                }
            );
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>